<template>
	<div id="user-access-page" :class="placedBackg">

		<div :class="container + ' ' + ((PINConfirm.usuarios_id) ? 'pinconfirm' : 'signup')">
			<div class="row mx-0 flex-center-xy page-size">

				<div id="mainFORM" class="form-container" v-if="!PINConfirm.usuarios_id">
					<div class="box-color"><i><u class="fas fa-user"></u></i></div>

					<slot name="default"></slot>

					<b-form class="form" @submit.prevent="register">

						<FormSignup v-model="form" />

						<div class="d-inline-block mb-3" v-if="!!form">
							<b-form-checkbox v-model="form.tos" name="usertype" value="1" unchecked-value="" required>
								* Acepto los
								<router-link to="/terminos-y-condiciones" target="_blank">
									términos y condiciones
								</router-link>
							</b-form-checkbox>
						</div>

						<vue-hcaptcha sitekey="93c03a3e-e398-4e32-b3c0-92d26152035c" @verify="onCaptchaValid" theme="dark"></vue-hcaptcha>

						<div class="mb-4 form-errors" v-if="formErrors.length">
							<hr />
							<ul>
								<li class="text-danger" v-for="(formError, formIndex) in formErrors" :key="formIndex">
									<small>{{ formError }}</small>
								</li>
							</ul>
						</div>

						<p class="mb-1 text-center">
							<router-link v-if="!hideLinks" to="/login">¿Ya tiene una cuenta?</router-link>

							<b-form-group class="mt-3">
								<b-button type="submit" class="btn-blue" variant="primary" v-if="!isProcessing">
									Crear cuenta
								</b-button>
								<b-button disabled class="btn-blue" variant="primary" v-else>
									Procesando
								</b-button>
							</b-form-group>
						</p>

					</b-form>
				</div>

				<div id="confirmPIN" class="form-container" v-else>

					<b-form class="form" @submit.prevent="try2ConfirmPIN">

						<h1 class="mb-3 mt-5">Confirma tu PIN</h1>

						<b-form-group label="* PIN">
							<b-form-input type="number" v-model="PINConfirm.pin" required />
						</b-form-group>

						<b-form-group class="mt-3">
							<b-button type="submit" class="btn-blue" variant="primary" v-if="!isProcessing">Confirmar
								PIN</b-button>
							<b-button disabled class="btn-blue" variant="primary" v-else>Procesando</b-button>
						</b-form-group>

					</b-form>
				</div>

			</div>
		</div>

		<sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block" ref="modal">
			<div class="fa-3x" v-if="modal.icon == ''"><i class="fas fa-spinner fa-pulse"></i></div><br />
			{{ modal.msg }}
			<div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
				<b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close();">OK</b-button>
			</div>
		</sweet-modal>

	</div>
</template>

<script>
import FormSignup from '../daniel/form-signup'
import { mapActions, mapGetters } from 'vuex';
import template from '../text-page/template.vue';

import VueHcaptcha from '@hcaptcha/vue-hcaptcha';

export default {
	components: { FormSignup, template, VueHcaptcha },

	computed: {
		...mapGetters(['isLogged']),
	},

	props: {
		hideLinks: {
			type: Boolean,
			default: false
		},
		loggedEvent: {
			type: String,
			default: 'logged'
		},
		avoidRedirectOnLogin: {
			type: Boolean,
			default: false
		},
		container: {
			type: String,
			default: 'container'
		},
		placedBackg: {
			type: String,
			default: 'placed-backg'
		}
	},

	data() {
		return {
			formErrors: [],

			isProcessing: false,

			PINConfirm: {
				usuarios_id: null,
				pin: null,
			},

			form: null,

			modal: {
				msg: '',
				icon: '',
				block: false,
			}

		}
	},

	methods: {
		...mapActions(['authSignUp', 'authConfirmPIN']),
		onCaptchaValid(token, ekey) {
			this.form.captcha = token;
			this.form.captchaEKey = ekey;
		},

		async try2ConfirmPIN() {
			this.isProcessing = true;
			const response = await this.authConfirmPIN(this.PINConfirm)
			if (response.status) {
				this.$emit(this.loggedEvent, response)
				if (this.isLogged && !this.avoidRedirectOnLogin) {
					this.$router.replace('/usuario')
				}
			}
			this.isProcessing = false;
		},

		async register(evt) {
			this.formErrors = [];
			this.isProcessing = true;

			if (this.form.password.length < 6) {
				this.formErrors.push("La contraseña debe tener por lo menos 6 caracteres");
				// this.modal.block = false;
				// this.modal.icon = 'error';
				// this.modal.msg = 'La contraseña debe tener por lo menos 6 caracteres';
				// this.$refs.modal.open();
			} 

			if (this.form.password !== this.form.password_confirm) {
				this.formErrors.push("Los campos contraseña y confirmación de contraseña deben coincidir");
				// this.modal.block = false;
				// this.modal.icon = 'error';
				// this.modal.msg = 'Los campos contraseña y confirmación de contraseña deben coincidir';
				// this.$refs.modal.open();
			} 

			if(this.form.captcha == null || this.form.captcha == ''){
				this.formErrors.push("Por favor, complete el captcha.");
				// this.modal.block = false;
				// this.modal.icon = 'error';
				// this.modal.msg = 'Por favor, complete el captcha.';
				// this.$refs.modal.open();
			}

			if (this.formErrors.length === 0) {
				let response = await this.authSignUp(this.form)
				if (!!response && response.status) {
					this.wait4PIN(response.data.usuarios_id)
				}
				console.debug(response)
			}

			this.isProcessing = false;
		},

		wait4PIN(usuarios_id) {
			this.PINConfirm.usuarios_id = usuarios_id;
		},

		handleErrors: function (errors) {
			var err = "";

			if (errors.response) {
				if (errors.response.data.errors) {
					jQuery.each(errors.response.data.errors, (k, v) => {
						err += "*" + v[0] + "\n";
					});
				}
			}
			else {
				console.log(errors);
				err = "Error desconocido.";
			}

			this.modal.icon = "error";
			this.modal.msg = err;
			this.modal.block = false;
			this.$refs.modal.open();

		}
	}
}
</script>

<style lang="scss" scoped>
#user-access-page {
	h2 {
		font-size: 1.25em;
		// color: #b6b7b7;
		text-align: center;
		font-weight: 200;
		line-height: 0.9;
	}
}
</style>